module.exports = __webpack_public_path__ + "img/HomeInsurance.88e981d5.webp";